import AdventCalendar from './components/AdventCalendar';

function App() {
  return <AdventCalendar />;
}

export default App;